import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import propertyTypeReducer from "./slices/propertyTypeSlice";
import clientReducer from "./slices/clientSlice";
import bailleurReducer from "./slices/bailleurSlice";
import manager from "./slices/managerSlice";
import announcement from "./slices/announcementSlice";
import reservation from "./slices/reservationSlice";
import disputes from "./slices/disputesSlice";
import reports from "./slices/reportSlice";
import statistics from "./slices/statisticSlice";
const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    propertyType: propertyTypeReducer,
    client: clientReducer,
    owner: bailleurReducer,
    manager,
    announcement,
    reservation,
    disputes,
    reports,
    statistics,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
